'use es6';

import { EXPERIMENT_TREATMENTS_REQUESTED, EXPERIMENT_TREATMENTS_RECEIVED } from 'pricing-pages-unified-ui/constants/ActionTypes';
import { resolveInAppTreatments, resolvePublicTreatments } from 'pricing-pages-unified-ui/api/ExperimentTreatmentApi';

const makeTreatmentsResolver = resolveTreatments => () => dispatch => {
  dispatch({
    type: EXPERIMENT_TREATMENTS_REQUESTED
  });
  return new Promise(resolvePromise => {
    resolveTreatments(treatments => {
      dispatch({
        type: EXPERIMENT_TREATMENTS_RECEIVED,
        payload: {
          treatments
        }
      });
      resolvePromise(treatments);
    });
  });
};

export const fetchExperimentTreatmentsFromEarlyRequest = makeTreatmentsResolver(resolveInAppTreatments);
export const fetchPublicExperimentTreatmentsFromEarlyRequest = makeTreatmentsResolver(resolvePublicTreatments);